<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="d-grid grid-prospect gap-32">
        <div>
          <div class="prospect-card">
            <div class="d-grid prospect-title">
              <div class="d-grid card-buttons-1 align-self-end">
                <div class="menu-container">
                  <div class="btn-group"></div>
                </div>
              </div>
            </div>
            <div class="sidebar-nav">
              <div
                class="nav-item"
                *ngFor="let item of menuOpciones"
                [class.active]="item.key === vistaActual"
                (click)="cambiarVista(item.key)"
              >
                <img
                  [src]="item.icon"
                  class="nav-icon"
                  alt="{{ item.label }}"
                />
                <span class="label">{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="prospect-info"
          *ngIf="vistaActual === 'usuarios' && !mostrarModificarUsuario"
        >
          <div class="white-card">
            <div class="header-title-row">
              <div class="header-left">
                <img
                  src="assets/svg/icon-orange.svg"
                  alt="Presupuestos"
                  class="center-svg"
                />
                <h1 class="text-semibold color-org t-24">Usuarios</h1>
                <div class="dropdown-wrapper" #dropdownContainer>
                  <div
                    class="dropdown-trigger"
                    (click)="toggleRecentDropdown()"
                  >
                    <span
                      >{{selectedItem === 'activos' ? 'Usuarios Activos' :
                      'Todos los Usuarios'}}</span
                    >
                    <span [class.rotated]="showRecentDropdown">▼</span>
                    <div
                      class="dropdown-menu"
                      [class.show]="showRecentDropdown"
                    >
                      <button
                        class="dropdown-item"
                        [class.selected]="selectedItem === 'todos'"
                        (click)="selectItem('todos')"
                      >
                        <span
                          class="check-icon"
                          *ngIf="selectedItem === 'todos'"
                          >✔</span
                        >
                        Todos los Usuarios
                      </button>
                      <button
                        class="dropdown-item"
                        [class.selected]="selectedItem === 'activos'"
                        (click)="selectItem('activos')"
                      >
                        <span
                          class="check-icon"
                          *ngIf="selectedItem === 'activos'"
                          >✔</span
                        >
                        Usuarios Activos
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="header-actions">
                <button
                  class="action-btn outline"
                  (click)="openMdlCreateUser()"
                >
                  <img
                    class="color-org"
                    src="assets/svg/plus-orange.svg"
                    alt="Añadir nuevo"
                    width="16"
                    height="16"
                  />
                  Añadir usuario
                </button>
              </div>
            </div>
            <div class="header-stats mt-3">
              <span>Organiza y administra a los usuarios del sistema.</span>
              <!-- Mostrar filtros activos -->
              <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                Filtros aplicados
                <button (click)="clearFilters()" class="clear-filters-btn">×</button>
              </span>
            </div>

            <div
              class="selection-container mt-4"
              *ngIf="usuariosSeleccionados > 0"
            >
              <div class="selection-info">
                <span class="selection-count"
                  >{{ usuariosSeleccionados }} Usuarios seleccionados</span
                >
                <div class="actions-divider"></div>
                <div class="actions-container">
                  <div
                    class="actions-dropdown"
                    (click)="toggleActionsDropdown()"
                  >
                    <span class="dropdown-label">Seleccionar acción</span>
                    <span
                      class="dropdown-arrow"
                      [class.rotated]="showActionsDropdown"
                      >▼</span
                    >
                  </div>
                  <div
                    class="dropdown-content"
                    [class.show]="showActionsDropdown"
                  >
                    <a
                      class="dropdown-item"
                      (click)="ejecutarAccion('eliminar')"
                      >Eliminar usuarios seleccionados</a
                    >
                    <a
                      class="dropdown-item"
                      (click)="ejecutarAccion('desactivar')"
                      >Desactivar usuarios seleccionados</a
                    >
                    <a class="dropdown-item" (click)="ejecutarAccion('activar')"
                      >Activar usuarios seleccionados</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="content-area mt-5">
              <div *ngIf="errorMessage" class="error-message">
                {{errorMessage}}
              </div>
              <div *ngIf="!isLoading && usuarios.length > 0">
                <div
                  class="d-grid search-bar-container"
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    gap: 16px;
                  "
                >
                  <div
                    class="npt-table-search-bar d-grid"
                    style="flex: 1; min-width: 0"
                  >
                    <div><img src="assets/svg/search.svg" alt="" /></div>
                    <input
                      type="text"
                      class="npt-nav-search"
                      placeholder="Buscar en esta lista..."
                      [(ngModel)]="searchTerm"
                      (input)="onSearchChange()"
                      style="flex: 1; min-width: 0; width: 100%"
                    />
                  </div>
                  <div style="display: flex; gap: 12px; flex-shrink: 0">
                    <button
                      class="search-btn"
                      (click)="cargarUsuarios()"
                      style="
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        white-space: nowrap;
                      "
                    >
                      <img src="assets/svg/reload-icon.svg" alt="Actualizar" />
                      <span>Actualizar</span>
                    </button>
                    <button
                      class="search-btn"
                      (click)="openFilterModal()"
                      style="
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        white-space: nowrap;
                      "
                    >
                      <img src="assets/svg/filtrar-icon.svg" alt="Filtrar" />
                      <span>Filtrar</span>
                    </button>
                  </div>
                </div>

                <div class="prospectos-table mh-50">
                  <table>
                    <thead>
                      <tr>
                        <th class="checkbox-column text-center">
                          <input
                            type="checkbox"
                            [checked]="todosSeleccionados"
                            (change)="toggleSeleccionTodos($event)"
                          />
                        </th>
                        <th 
                          (click)="sortByColumn('nombre')"
                          [class.sorted]="sortColumn === 'nombre'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span>Nombre Completo</span>
                            <span *ngIf="sortColumn === 'nombre'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'nombre'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th 
                          (click)="sortByColumn('alias')"
                          [class.sorted]="sortColumn === 'alias'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span>Alias</span>
                            <span *ngIf="sortColumn === 'alias'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'alias'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th 
                          (click)="sortByColumn('email')"
                          [class.sorted]="sortColumn === 'email'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span>Correo</span>
                            <span *ngIf="sortColumn === 'email'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'email'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th 
                          (click)="sortByColumn('ultimo_login')"
                          [class.sorted]="sortColumn === 'ultimo_login'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span>Último inicio de sesión</span>
                            <span *ngIf="sortColumn === 'ultimo_login'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'ultimo_login'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th 
                          (click)="sortByColumn('activo')"
                          [class.sorted]="sortColumn === 'activo'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span style="color: black">Activo</span>
                            <span *ngIf="sortColumn === 'activo'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'activo'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th 
                          (click)="sortByColumn('perfil')"
                          [class.sorted]="sortColumn === 'perfil'"
                          class="sortable-header"
                        >
                          <div class="column-header">
                            <span>Perfil</span>
                            <span *ngIf="sortColumn === 'perfil'" class="sort-indicator">
                              {{ sortDirection === 'asc' ? '↑' : '↓' }}
                            </span>
                            <img *ngIf="sortColumn !== 'perfil'" src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                        <th class="sortable-column">
                          <div class="column-header">
                            <span>Acciones</span>
                            <img src="assets/svg/arrow-down-black.svg" alt="Ordenar" class="sort-icon" />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let usuario of usuariosFiltrados; let i=index"
                        [class.contacto-invalido]="!usuario.usuario_id"
                      >
                        <td class="checkbox-column">
                          <input
                            type="checkbox"
                            [checked]="isUsuarioSeleccionado(usuario.usuario_id)"
                            (change)="toggleSeleccionUsuario(usuario, $event)"
                            (click)="$event.stopPropagation()"
                          />
                        </td>
                        <td>{{usuario.nombre}} {{usuario.apellido}}</td>
                        <td>{{ usuario.alias }}</td>
                        <td>{{ usuario.email }}</td>
                        <td>
                          <span
                            class="ultimo-login"
                            [title]="usuario.ultimo_login"
                          >
                            {{ usuario.ultimo_login | date:'dd/MM/yyyy HH:mm'}}
                          </span>
                        </td>
                        <td class="checkbox-column text-center">
                          <input
                            type="checkbox"
                            [checked]="usuario.activo === 1"
                            disabled
                            class="visual-checkbox"
                          />
                        </td>
                        <td>{{ usuario.perfil }}</td>
                        <td class="actions-cell">
                          <div class="action-links">
                            <span
                              class="link-modificar"
                              style="text-decoration: underline"
                              (click)="updateUser(usuario); $event.stopPropagation()"
                            >
                              <img
                                src="assets/svg/orange-pen-icon.svg"
                                alt="Modificar"
                              />
                              Modificar
                            </span>
                            <span
                              class="link-eliminar"
                              style="text-decoration: underline"
                              (click)="openMdlDeleteUser(usuario); $event.stopPropagation()"
                            >
                              <img
                                src="assets/svg/orange-trash-can-icon.svg"
                                alt="Eliminar"
                              />
                              Eliminar
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                *ngIf="!isLoading && usuarios.length === 0 && !errorMessage"
                class="empty-state"
              >
                <div class="empty-content">
                  <div class="empty-image">
                    <img
                      src="assets/img/listausuarios.png"
                      alt="Lista de usuarios vacía"
                    />
                  </div>
                  <h2>Sin Usuarios por ahora</h2>
                  <p>
                    Todavía no tienes usuarios registrados. Puedes comenzar
                    agregando uno nuevo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--hasta aqui llega la vista de la tabla de los usuarios-->

        <!-- Vista de modificación -->
        <div class="prospect-info" *ngIf="mostrarModificarUsuario">
          <div class="white-card">
            <div class="header-title-row">
              <div class="header-left">
                <button
                  class="back-button"
                  (click)="volverATablaUsuarios()"
                  style="width: 60px; height: 60px"
                >
                  <img
                    src="assets/svg/icon-orange.svg"
                    alt="Volver"
                    class="center-svg"
                  />
                </button>
                <h1 class="text-semibold color t-24">
                  Modificar usuario: {{usuarioSeleccionado?.nombre}}
                  {{usuarioSeleccionado?.apellido}}
                </h1>
              </div>

              <div class="form-actions-inline">
                <button
                  class="user-btn user-btn-secondary"
                  (click)="volverATablaUsuarios()"
                >
                  Cancelar
                </button>
                <button
                  class="user-btn user-btn-primary"
                  (click)="guardarCambiosUsuario()"
                >
                  Guardar
                </button>
              </div>
            </div>

            <div class="header-stats mt-3">
              <span>Edita la información y permisos de este usuario.</span>
            </div>

            <!--informacion general   -->
            <div class="modificar-usuario-content">
              <div class="section-header">
                <img
                  src="assets/svg/clock-black.svg"
                  alt="Información general"
                  class="section-icon"
                />
                <h3 class="section-titles">Información general</h3>
              </div>

              <div class="user-info-grid">
                <div class="info-item">
                  <label>Nombres:</label>
                  <input
                    type="text"
                    [(ngModel)]="usuarioSeleccionado.nombre"
                    class="form-input"
                  />
                </div>

                <div class="info-item">
                  <label>Perfil:</label>
                   <select class="form-input" [(ngModel)]="usuarioSeleccionado.rolId" required>
            <option value="">-- Selecciona el tipo de perfil --</option>
            <option *ngFor="let rol of rolesDisponibles" [value]="rol.id">
              {{rol.name}}
            </option>
          </select>
                </div>
                <div class="info-item">
                  <label>Apellidos:</label>
                  <input
                    type="text"
                    [(ngModel)]="usuarioSeleccionado.apellido"
                    class="form-input"
                  />
                </div>
                <div class="info-item">
                  <label>Correo:</label>
                  <input
                    type="email"
                    [(ngModel)]="usuarioSeleccionado.email"
                    class="form-input"
                  />
                </div>
               

                <div class="info-item">
                  <label>Alias:</label>
                  <input
                    type="text"
                    [(ngModel)]="usuarioSeleccionado.alias"
                    class="form-input"
                    readonly
                  />
                </div>
                <div class="info-item">
                  <label>Activo:</label>
                  <td class="checkbox-column text-center">
                    <input
                      type="checkbox"
                      [checked]="usuarioSeleccionado.activo === 1"
                      (click)="$event.stopPropagation(); toggleUsuarioActivo(usuarioSeleccionado)"
                    />
                  </td>
                </div>
                <div class="info-item">
                  <label>Nueva contraseña:</label>
                  <div class="password-field" style="display:flex; align-items:center; gap:12px;">
                    <input
                      [type]="mostrarNuevaContrasena ? 'text' : 'password'"
                      [(ngModel)]="usuarioSeleccionado.nuevaContrasena"
                      class="form-input"
                      placeholder="Opcional"
                    />
                    <button type="button" class="btn btn-primary-outline" (click)="mostrarNuevaContrasena = !mostrarNuevaContrasena">
                      {{ mostrarNuevaContrasena ? 'Ocultar' : 'Mostrar' }}
                    </button>
                  </div>
                </div>
                
                
                
              </div>

              <div class="section-header">
                <img
                  src="assets/svg/clock-black.svg"
                  alt="Permitir accesos"
                  class="section-icon"
                />
                <h3 class="section-titles">Permitir accesos</h3>
              </div>

              <!-- Tabla de permisos  -->
              <div
                class="prospectos-table permisos-table-container auto-width-table"
              >
                <table class="table-auto w-full border border-gray-300">
                  <thead>
                    <tr class="bg-gray-100">
                      <th class="p-2 border border-gray-300 w-48 text-left">
                        Módulo
                      </th>
                      <th
                        *ngFor="let accion of primerosModulos[0].acciones"
                        class="p-2 border border-gray-300 text-center"
                      >
                        {{ accion }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let modulo of primerosModulos">
                      <td class="p-2 border border-gray-300">
                        {{ modulo.modulo }}
                      </td>
                      <td
                        *ngFor="let accion of modulo.acciones"
                        class="checkbox-column text-center"
                        
                      >
                        <input
                          type="checkbox"
                          [checked]="permisosUsuario[modulo.modulo][accion]"
                          (change)="togglePermiso(modulo.modulo, accion)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Tablas independientes para el resto de los módulos -->
              <div
                *ngFor="let modulo of modulos.slice(5)"
                class="prospectos-table permisos-table-container auto-width-table"
              >
                <table class="table-auto w-full border border-gray-300">
                  <thead>
                    <tr class="bg-gray-100">
                      <th class="p-2 border border-gray-300 w-48 text-left">
                        Módulo
                      </th>
                      <th
                        *ngFor="let accion of modulo.acciones"
                        class="p-2 border border-gray-300 text-center"
                      >
                        {{ accion }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="p-2 border border-gray-300">
                        {{ modulo.modulo }}
                      </td>
                      <td
                        *ngFor="let accion of modulo.acciones"
                        class="checkbox-column text-center"
                      >
                        <input
                          type="checkbox"
                          [checked]="permisosUsuario[modulo.modulo][accion]"
                          (change)="togglePermiso(modulo.modulo, accion)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Vista de Cambiar Contraseña -->
        <div class="prospect-info" *ngIf="vistaActual === 'cambiar-contrasena'">
          <div class="white-card">
            <div class="header-title-row">
              <div class="header-left">
                <button
                  class="back-button"
                  (click)="cambiarVista('usuarios')"
                  style="width: 60px; height: 60px"
                >
                  <img
                    src="assets/svg/change-pass-icon.svg"
                    alt="Volver"
                    class="center-svg"
                  />
                </button>
                <h1 class="text-semibold color t-24">Cambiar contraseña</h1>
              </div>
            </div>

            <div class="header-stats mt-3">
              <span>Gestiona la contraseña asociada a tu usuario.</span>
            </div>

            <div class="last-password-change">
              <p>
                La última vez que cambiaste tu contraseña fue el
                {{ultimoCambioContrasena | date:'dd/MM/yyyy HH:mm'}} hrs.
              </p>
            </div>

            <div class="password-change-layout">
              <div class="password-form-column">
                <div class="form-row">
                  <label class="form-label">Contraseña actual:</label>
                  <input
                    class="form-input"
                    type="password"
                    [(ngModel)]="contrasenaActual"
                    placeholder="Ingresa tu contraseña actual"
                    (input)="validarContrasena()"
                  />
                </div>

                <div class="form-row">
                  <label class="form-label">Contraseña nueva:</label>
                  <input
                    class="form-input"
                    type="password"
                    [(ngModel)]="nuevaContrasena"
                    placeholder="Ingresa tu nueva contraseña"
                    (input)="validarContrasena()"
                  />
                </div>

                <div class="form-row">
                  <label class="form-label">Confirmar nueva contraseña:</label>
                  <input
                    class="form-input"
                    type="password"
                    [(ngModel)]="confirmarContrasena"
                    placeholder="Confirma tu nueva contraseña"
                    (input)="validarContrasena()"
                  />
                </div>

                <div
                  class="password-match-text"
                  *ngIf="nuevaContrasena && confirmarContrasena"
                >
                  <span
                    [class.valid]="contrasenasCoinciden"
                    [class.invalid]="!contrasenasCoinciden"
                  >
                    {{contrasenasCoinciden ? '✓ Las contraseñas coinciden' : '✗
                    Las contraseñas no coinciden'}}
                  </span>
                </div>

                <div class="form-actions">
                  <button
                    class="user-btn-primary"
                    (click)="cambiarContrasena()"
                    [disabled]="!formularioContrasenaValido || ambiandoContrasena"
                  >
                    {{ ambiandoContrasena ? 'Cambiando...' : 'Cambiar
                    contraseña' }}
                  </button>
                </div>
              </div>

              <div class="password-requirements-column">
                <div class="instructions-text">
                  <h3>
                    Establece una nueva contraseña para tu cuenta
                    <strong>{{emailUsuario}}</strong>. Asegúrate de que cumpla
                    con los siguientes requisitos:
                  </h3>
                </div>

                <ul class="requirements-list">
                  <li [class.valid]="cumpleLongitud">
                    <span class="check-icon"
                      >{{cumpleLongitud ? '✓' : '○'}}</span
                    >
                    Al menos 8 caracteres.
                  </li>
                  <li [class.valid]="cumpleMayuscula">
                    <span class="check-icon"
                      >{{cumpleMayuscula ? '✓' : '○'}}</span
                    >
                    Una letra mayúscula.
                  </li>
                  <li [class.valid]="cumpleNumero">
                    <span class="check-icon">{{cumpleNumero ? '✓' : '○'}}</span>
                    Un número.
                  </li>
                  <li [class.valid]="cumpleEspecial">
                    <span class="check-icon"
                      >{{cumpleEspecial ? '✓' : '○'}}</span
                    >
                    Un símbolo especial (como @, #, $, *).
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Vista de Cambiar Contraseña -->

        <!-- Vista de Datos Personales -->
        <div class="prospect-info" *ngIf="vistaActual === 'datos'">
          <div class="white-card">
            <div class="header-title-row">
              <div class="header-left">
                <button
                  class="back-button"
                  (click)="cambiarVista('usuarios')"
                  style="width: 60px; height: 60px"
                >
                  <img
                    src="assets/svg/personal-data-icon.svg"
                    alt="Volver"
                    class="center-svg"
                  />
                </button>
                <h1 class="text-semibold color t-24">Datos personales</h1>
              </div>
            </div>

            <div class="header-stats mt-3">
              <span
                >Gestiona los datos principales de tu perfil dentro del
                sistema.</span
              >
            </div>

            <!-- Información personal -->
            <div class="modificar-usuario-content">
              <form #datosPersonalesForm="ngForm">
                <div class="user-info-grid">
                  <div class="info-item">
                    <label>Nombres:</label>
                    <input
                      type="text"
                      [(ngModel)]="nombreUsuario"
                      name="nombreUsuario"
                      class="form-input"
                      [readonly]="false"
                    />
                  </div>

                  <div class="info-item">
                    <label>Apellidos:</label>
                    <input
                      type="text"
                      [(ngModel)]="apellidoUsuario"
                      name="apellidoUsuario"
                      class="form-input"
                      [readonly]="false"
                    />
                  </div>

                  <div class="info-item">
                    <label>Correo:</label>
                    <input
                      type="email"
                      [(ngModel)]="emailUsuario"
                      name="emailUsuario"
                      class="form-input"
                      [readonly]="false"
                      placeholder="ejemplo@correo.com"
                    />
                  </div>

                  <div class="info-item">
                    <label>RUT:</label>
                    <input
                      type="text"
                      [(ngModel)]="rutUsuarioFormateado"
                      name="rutUsuario"
                      class="form-input"
                      [readonly]="false"
                      placeholder="Ej: 12.345.678-9"
                      (input)="formatearRUTEnTiempoReal()"
                      (blur)="formatearRUT()"
                      maxlength="12"
                      #rutInput
                    />
                    <div
                      *ngIf="rutUsuarioFormateado && !validarRUT(rutUsuarioFormateado)"
                      class="error-message"
                      style="color: red; font-size: 12px"
                    >
                      RUT inválido
                    </div>
                  </div>

                  <div class="info-item">
                    <label>Perfil:</label>
                    <input
                      type="text"
                      [value]="usuarioActivo?.rol"
                      class="form-input"
                      readonly
                    />
                  </div>

                  <div class="info-item">
                    <label>Estado:</label>
                    <input
                      type="text"
                      [value]="usuarioActivo?.activo === 1 ? 'Activo' : 'Inactivo'"
                      class="form-input"
                      readonly
                    />
                  </div>
                </div>

                <div class="user-info-grid">
                  <div class="info-item">
                    <label>Alias:</label>
                    <input
                      type="text"
                      [value]="generarAlias(nombreUsuario, apellidoUsuario)"
                      class="form-input"
                      readonly
                    />
                  </div>
                </div>

                <div class="user-info-grid">
                  <h1
                    style="
                      height: 20px;
                      font-size: 14px;
                      color: gray;
                      font-weight: normal;
                    "
                  >
                    La última vez que cambiaste tu contraseña fue el
                    <strong
                      >{{ ultimoCambioContrasena ? (ultimoCambioContrasena | date:'dd/MM/yyyy HH:mm') : 'Sin registro' }}
                      hrs.</strong
                    >
                    <span
                      style="
                        color: #fd7e14;
                        text-decoration: underline;
                        cursor: pointer;
                      "
                      (click)="cambiarVista('cambiar-contrasena')"
                    >
                      Cambiar contraseña
                    </span>
                  </h1>
                </div>
                <h1
                  style="
                    height: 20px;
                    font-size: 14px;
                    color: gray;
                    font-weight: normal;
                  "
                >
                  Fecha en que se creó esta cuenta
                  <strong
                    >{{fechaCreacionUsuario | date:'dd/MM/yyyy HH:mm'}}
                    hrs.</strong
                  >
                </h1>

                <!-- Botón para actualizar datos personales -->
                <div class="form-actions-inline" style="padding-top: 30px">
                  <button
                    class="btn-primary action-btn"
                    (click)="actualizarDatosPersonales()"
                    [disabled]="!datosPersonalesForm.valid"
                  >
                    Actualizar datos personales
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Vista de configuracion del correo -->
        <div class="prospect-info" *ngIf="vistaActual === 'correo'">
          <div class="white-card">
            <div class="header-title-row">
              <div class="header-left">
                <img
                  src="assets/svg/icon-orange.svg"
                  alt="Presupuestos"
                  class="center-svg"
                />
                <h1 class="text-semibold  t-24">Configuración de correo</h1>
                <div class="dropdown-wrapper" #dropdownContainer>
                  <div
                    class="dropdown-trigger"
                    (click)="toggleRecentDropdown()"
                  >
                    <span>{{outlookMail !== '' ? 'Cuenta vinculada' : 'Cuenta sin vincular'}}</span
                    >
                    <span [class.rotated]="showRecentDropdown"></span>
                    <div
                      class="dropdown-menu"
                      [class.show]="showRecentDropdown"
                    >
                      <button
                        class="dropdown-item"
                        [class.selected]="selectedItem === 'todos'"
                        (click)="selectItem('todos')"
                      >
                        <span
                          class="check-icon"
                          *ngIf="selectedItem === 'todos'"
                          >✔</span
                        >
                        Todos los Usuarios
                      </button>
                      <button
                        class="dropdown-item"
                        [class.selected]="selectedItem === 'activos'"
                        (click)="selectItem('activos')"
                      >
                        <span
                          class="check-icon"
                          *ngIf="selectedItem === 'activos'"
                          >✔</span
                        >
                        Usuarios Activos
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="header-stats mt-3">
              <span>
                Vincula tu cuenta de Outlook para sincronizar correo y calendario directamente en el CRM.
              </span>
              <p></p>
              <span>
                Tus credenciales están protegidas y solo se utilizarán para la integracion.
                </span>
            </div>

            @if(outlookMail !== ''){
              <h3 class="color-gray">Tu cuenta de Outlook está vinculada</h3>

              <div class="d-flex mt-3">
                <label for="">Cuenta sincronizada con: </label>
                <input type="crm-input" disabled [value]="outlookMail" style="margin-left: 10px; width: 300px;">
              </div>
            }

            <div class="form-actionss mt-5">
              @if(outlookMail === ''){
                <button class="btn-primary action-btn" (click)="connectOutlook()">
                  Conectar con outlook
                </button>
              }@else{
                <button class="btn-primary action-btn" (click)="openUnlinkMdl()">
                  Desvincular cuenta
                </button>
              }
            </div>
          </div>

          <!-- Vista de configuracion del correo -->

          <!--mensaje de cuando no se ve la tabla-->
          <div
            class="prospect-info"
            *ngIf="!vistaActual && !mostrarModificarUsuario"
          >
            <div class="white-card">
              <div class="empty-state">
                <div class="empty-content">
                  <h2>Selecciona una opción del menú</h2>
                  <p>
                    Haz clic en alguna de las opciones del menú lateral para ver
                    su contenido.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>